import { combineReducers } from 'redux';
import userLogin from './user';
import walletReducer from './wallet';

// Configure os seus reducers.
// ATENÇÃO: você obrigatoriamente tem que utilizar as chaves "user" e "wallet" no seu estado global

const rootReducer = combineReducers({ user: userLogin, wallet: walletReducer });

export default rootReducer;
